// frontend/admin-portal/src/components/products/CSVPreviewTable.jsx
import React, { useState } from "react";
import { Badge, Button, Table } from "@fiberhome/shared-ui";

const STATUS_VARIANT = {
  ok: "success",
  error: "danger",
};

const MATCH_VARIANT = {
  create: "primary",
  update: "warning",
  skip: "default",
};

export default function CSVPreviewTable({ rows = [] }) {
  const [filter, setFilter] = useState("all");

  const filtered = rows.filter((r) => {
    if (filter === "valid") return r.status === "ok";
    if (filter === "error") return r.status === "error";
    if (filter === "create")
      return r.status === "ok" && r.matchType === "create";
    if (filter === "update")
      return r.status === "ok" && r.matchType === "update";
    if (filter === "skip") return r.status === "ok" && r.matchType === "skip";
    return true;
  });

  const counts = {
    all: rows.length,
    valid: rows.filter((r) => r.status === "ok").length,
    error: rows.filter((r) => r.status === "error").length,
    create: rows.filter((r) => r.status === "ok" && r.matchType === "create")
      .length,
    update: rows.filter((r) => r.status === "ok" && r.matchType === "update")
      .length,
    skip: rows.filter((r) => r.status === "ok" && r.matchType === "skip")
      .length,
  };

  const columns = [
    { key: "line", label: "#", width: 60 },
    {
      key: "status",
      label: "Status",
      width: 100,
      render: (r) => (
        <Badge variant={STATUS_VARIANT[r.status]}>{r.status}</Badge>
      ),
    },
    {
      key: "matchType",
      label: "Action",
      width: 100,
      render: (r) => (
        <Badge variant={MATCH_VARIANT[r.matchType]}>{r.matchType}</Badge>
      ),
    },
    {
      key: "name",
      label: "Product",
      render: (r) => (
        <div>
          <div style={{ fontWeight: 600 }}>{r.raw.name || "—"}</div>
          <div className="text-muted" style={{ fontSize: 12 }}>
            {r.raw.sku || "(no SKU)"}
          </div>
        </div>
      ),
    },
    {
      key: "category",
      label: "Category",
      render: (r) => r.raw.category || <span className="text-muted">—</span>,
    },
    {
      key: "brand",
      label: "Brand",
      render: (r) => r.raw.brand || <span className="text-muted">—</span>,
    },
    { key: "price", label: "Price", render: (r) => r.raw.price || "—" },
    { key: "stock", label: "Stock", render: (r) => r.raw.stock || "—" },
    {
      key: "issues",
      label: "Issues",
      render: (r) => {
        const items = [
          ...r.errors.map((e) => ({ type: "error", text: e })),
          ...r.warnings.map((w) => ({ type: "warn", text: w })),
        ];
        if (!items.length) return <span className="text-muted">—</span>;
        return (
          <ul className="fh-import-issues">
            {items.map((it, i) => (
              <li
                key={i}
                className={`fh-import-issue fh-import-issue--${it.type}`}
              >
                {it.text}
              </li>
            ))}
          </ul>
        );
      },
    },
  ];

  const filters = [
    { id: "all", label: `All (${counts.all})` },
    { id: "valid", label: `Valid (${counts.valid})` },
    { id: "error", label: `Errors (${counts.error})` },
    { id: "create", label: `New (${counts.create})` },
    { id: "update", label: `Update (${counts.update})` },
    { id: "skip", label: `Skip (${counts.skip})` },
  ];

  return (
    <>
      <div className="fh-import-filters">
        {filters.map((f) => (
          <Button
            key={f.id}
            size="sm"
            variant={filter === f.id ? "primary" : "ghost"}
            onClick={() => setFilter(f.id)}
          >
            {f.label}
          </Button>
        ))}
      </div>
      <div className="mt-3">
        <Table
          columns={columns}
          data={filtered}
          emptyMessage="No rows match this filter"
        />
      </div>
    </>
  );
}
